@for (sort of options$ | async; track $index) {
  <div class="sort-header">
    <app-sort-header-option
      [attr.data-test-id]="sort.id + '-sort-option'"
      [icon]="sort?.icon"
      [sortEnabled]="isSortable(sort)"
      [text]="sort.translationKey"
      [infoTooltipText]="sort.infoTooltipTranslation"
      [sortDirection]="isCaretShown(sort) ? selectedDirection : undefined"
      (click)="selectHeaderSortAsync(sort)"
    ></app-sort-header-option>
  </div>
}
